import { actionTypes } from 'actions/recipe/actionTypes';

const initState = {
  listDataRecipe: {
    data: null
  },
  loadingGetList: false,
  loadingCreateRecipe: false,
  loadingEditRecipe: false,
  detailRecipe: {},
  dataCreateIngredient: null,
  dataCreateInstruction: null,
  loadingDetailRecipe: false,
  loadingCreateIngredient: false,
  loadingCreateInstruction: false,
  updateRecipe: null,
  deleteRecipe: null,
  deleteImageRecipe: null
};

export default (state: any = initState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.CLEAR_LIST_RECIPE:
      return {
        ...state,
        listDataRecipe: {
          data: null
        }
      }
    case actionTypes.GET_LIST_RECIPES:
      return {
        ...state,
        loadingGetList: true
      };
    case actionTypes.GET_LIST_RECIPES_FAIL:
      return {
        ...state,
        loadingGetList: false
      };
    case actionTypes.GET_LIST_RECIPES_SUCCESS:
      return {
        ...state,
        listDataRecipe: payload,
        loadingGetList: false
      };
    case actionTypes.CREATE_RECIPE:
      return {
        ...state,
        loadingCreateRecipe: true
      };
    case actionTypes.CREATE_RECIPE_FAIL:
      return {
        ...state,
        loadingCreateRecipe: false
      };
    case actionTypes.CREATE_RECIPE_SUCCESS:
      return {
        ...state,
        loadingCreateRecipe: false,
      };
    case actionTypes.GET_RECIPE_DETAIL_SUCCESS:
      return {
        ...state,
        detailRecipe: payload,
        loadingDetailRecipe: false,
      };
    case actionTypes.CREATE_INGREDIENT:
      return {
        ...state,
        loadingCreateIngredient: true,
      };
    case actionTypes.CREATE_INGREDIENT_FAIL:
      return {
        ...state,
        loadingCreateIngredient: false
      };
    case actionTypes.CREATE_INGREDIENT_SUCCESS:
      return {
        ...state,
        loadingCreateIngredient: false,
        dataCreateIngredient: payload,
      };
    case actionTypes.CREATE_INSTRUCTION:
      return {
        ...state,
        loadingCreateInstruction: true,
      };
    case actionTypes.CREATE_INSTRUCTION_FAIL:
      return {
        ...state,
        loadingCreateInstruction: false
      };
    case actionTypes.CREATE_INSTRUCTION_SUCCESS:
      return {
        ...state,
        loadingCreateInstruction: false,
        dataCreateInstruction: payload,
      };
    case actionTypes.UPDATE_RECIPE:
      return {
        ...state,
        loadingEditRecipe: true,
      };
    case actionTypes.UPDATE_RECIPE_SUCCESS:
      return {
        ...state,
        updateRecipe: payload,
        loadingEditRecipe: false,
      };
    case actionTypes.UPDATE_RECIPE_FAIL:
      return {
        ...state,
        loadingEditRecipe: false,
      };
    case actionTypes.DELETE_RECIPE_SUCCESS:
      return {
        ...state,
        deleteRecipe: payload
      };
    case actionTypes.DELETE_IMAGE_RECIPE_SUCCESS:
      return {
        ...state,
        deleteImageRecipe: payload
      };
    default:
      return state;
  }
};
